import React, { MouseEvent } from 'react';
import { faThumbsUp as falThumbsUp } from '@fortawesome/pro-light-svg-icons/faThumbsUp';
import { faThumbsUp as fasThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

type Props = {
    active: boolean;
    className?: string;
    count: number;
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    submitted: boolean;
};

const Helpful = (props: Props) => {
    const { active, className, count, onClick, submitted } = props;
    const icon = active ? fasThumbsUp : falThumbsUp;

    if (submitted) {
        return <LoadingThrobber />;
    }

    return (
        <StyledButton className={className} disabled={submitted} onClick={onClick}>
            <FormattedMessage id="review.helpful" />
            <FontAwesomeIcon icon={icon} /> {count}
        </StyledButton>
    );
};

export default React.memo<Props>(Helpful, isEqual);

const StyledButton = styled.button`
    color: ${({ theme }) => theme.colors.blue100};
    background: none;
    border: none;
    outline: none;
    display: flex;
    padding-left: 0;

    :hover {
        color: ${({ theme }) => theme.colors.blue200};
    }
`;

const LoadingThrobber = styled(Throbber)`
    padding-right: 91px;
`;
